export const isNumber = (value) => {
  //with floats
  return /^\d+\.?\d{0,2}$/.test(value);
};

export const isInteger = (value) => {
  //no floats -- /^[0-9\b]+$/; -- /[0-9]$/;
  return /^[0-9]+$/.test(value);
};

export const isAlphaNumeric = (value) => {
  //start alphabet, no multiple spaces, allows numbers
  return /^([a-zA-Z]+(\s){0,1})+(\s{0,1}[a-zA-Z0-9]\s{0,1})*$/.test(value);
};

export const isAlphabet = (value) => {
  //only alphabets
  return /^([a-zA-Z]+(\s){0,1})+([a-zA-Z]\s{0,1})*$/.test(value);
};

export const isEmail = (value) => {
  //match Email
  return /^[a-zA-Z0-9._-]+@[a-zA-Z0-9._]+\.[a-zA-Z]{2,4}$/.test(value);
};


export const removeSpace = (value) => {
  return value?.replace(/\s/g, '')
}